

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/service/http.service';
import { GlobalcfgService } from '../../../../../../service/globalcfg.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { DatePipe, Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-view-samples-pending',
  templateUrl: './view-samples-pending.component.html',
  styleUrls: ['./view-samples-pending.component.css']
})
export class ViewSamplesPendingComponent implements OnInit {
  filterTerm: any;
  orgList = [];
  orders = [
    {
      name: 'Automatic',
      id: 1
    },
    {
      name: 'Manual',
      id: 2
    }
  ]

  p: any
  searchTexts: any;
  items: any = [];
  config: any;
  mainData: any;
  radioForm: FormGroup;

  currentTab: string = 'Pending';
  morphine: any;
  consistency: any;
  morphineDob: any;
  stage: any;
  id: string;
  dateList: any[];
  constructor(private httpService: HttpService, private router: Router, private globalcfgService: GlobalcfgService, private formBuilder: FormBuilder,
    private authGuard: AuthGuard, private location: Location, private spinner: NgxSpinnerService,    private _Activatedroute: ActivatedRoute,
    ) {

  }

  ngOnInit(): void {
    this.config = {
      currentPage: 1,
      itemsPerPage: 20
    };
    this.radioForm = this.formBuilder.group({
      batchProcess: [''],
    });
    this.radioForm.patchValue({ batchProcess: "Automatic" })
    this._Activatedroute.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.loadChallanList();
    });
  }

  pageChange(newPage: number) {
    this.config.currentPage = newPage;

  }



  loadChallanList() {

    
    const userId = localStorage.getItem('uuid');

    const trayObject = [
      {
        _methodId: "47",
        _trayId: this.id,
        _userId: userId,
      },
    ];
     this.spinner.show();
    this.httpService.editTray(trayObject).subscribe(
      (result) => {
        console.log(result)
      this.spinner.hide();
     // console.log(data);
     this.orgList = result.responseData[1];

      const samplesReceivedData = JSON.parse(localStorage.getItem('samplesReceivedData'));
      this.stage = samplesReceivedData.samplingStatus;
       if( this.orgList &&  this.orgList.length > 0){
        this.orgList.sort((a, b) => (a.trayId > b.trayId) ? 1 : -1)
        this.orgList.forEach(org=>{
          org.Morphine =    org.Morphine === 0 ? null: org.Morphine.toFixed(2);
          org.Consistency =    org.Consistency === 0 ? null: org.Consistency.toFixed(2);
  
          org.Morphine_ODB =    org.Morphine_ODB === 0 ? null: org.Morphine_ODB.toFixed(2);
        
        })
       }
     

    });
  }



  backButton() {
    this.location.back()
  }
  async generateExcel() {
    let sumNetWt = 0;

    for (let i = 0; i < this.orgList.length; i++) {
      sumNetWt = sumNetWt + this.orgList[i].net_weight;
    }
  
    this.dateList = this.orgList;
    const header = ['S.No.', 'Sample Unique  Number', 'Morphine(%)', 'Consistency', 'Morphine(ODB)'];


    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Verifier');
    // Add Row and formatting


  
  

    

 
   

  


    worksheet.mergeCells('A1:D2');


    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      };
      cell.font = { size: 9 };
      cell.alignment = { horizontal: 'center' };
    });


    for (let i = 0; i < this.dateList.length; i++) {
      const row = worksheet.addRow([i + 1, this.orgList[i].qrcode_unique, this.orgList[i].Morphine, this.orgList[i].Consistency, this.orgList[i].Morphine_ODB]);
      row.eachCell((cell, number) => {
        cell.font = { size: 9 };
        cell.alignment = { horizontal: 'center' };
      })
      const qty = row.getCell(6);

    }
    worksheet.getColumn(1).width = 15;
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'TrayNumber.xlsx');
    });


  }
  edit(sample) {
    const traySequence = sample.qrcode_unique === null ? '' : sample.qrcode_unique;
    const Morphine = sample.Morphine === null ? '' : sample.Morphine;
    const Consistency = sample.Consistency === null ? '' : sample.Consistency;
    const fc = sample.fc;
    Swal.fire({
      title: 'Edit Values',
      html: `
    <p>Sample Number</p>
    <input type="text" id="sampleNumber" readonly value="${traySequence}" class="swal2-input" placeholder="Sample No.">
    <p>Morphine%</p>
    <input type="text" id="morphine" value="${Morphine}"   class="swal2-input" placeholder="Morphine">
    <p>Consistency</p>
    <input type="text" id="consistency" value="${Consistency}"  class="swal2-input" placeholder="Consistency">
    `,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,

      focusConfirm: false,
      customClass: {
        container: 'my-swal-add-challan',
        confirmButton: 'your-confirm-button-class-one',
        cancelButton: 'your-cancel-button-class-one',

      },
      preConfirm: () => {
        let sampleNumber = Swal.getPopup().querySelector('#sampleNumber')['value'];
         this.morphine = Swal.getPopup().querySelector('#morphine')['value'];
         this.consistency = Swal.getPopup().querySelector('#consistency')['value'];
        //  this.morphineDob = Swal.getPopup().querySelector('#morphineDob')['value'];

        if (!sampleNumber || !this.morphine || !this.consistency) {
          Swal.showValidationMessage(`Please enter the details`)

        }



      }
    }).then((result:any) => {
     // console.log(result);
      if(result['value']){
        const userId = localStorage.getItem('uuid');
        const sampleObject = {
          "_methodId": "41",
          "_consistency":this.consistency,
          "_morphine":this.morphine,
          "_fc":fc,
          "_trayId":sample.trayId,
          "_userId": userId
        }
        this.httpService.updateConsistency(sampleObject).subscribe(result => {
         this.loadChallanList();
         this.morphine = '';
         this.morphineDob = '';
         this.consistency = ''
        })
      }
      
      
      
    })
  }

}





